import { bl_alg_cc_qc_set_project_link_RowClass } from "../../../../dbschema/bl_alg_cc_qc_set_project_link.model";
import { BaseContainerModel } from "../../../base-container.model";

export class QualityControlSetProjectLinkContainerModel extends BaseContainerModel {
    bl_alg_cc_qc_set_project_link: bl_alg_cc_qc_set_project_link_RowClass = new bl_alg_cc_qc_set_project_link_RowClass();    
}
